import React, { useEffect } from "react"

import PayairEcomWrapperSdk from "@payair/e-com-wrapper-sdk"
import payairGooglePay from "@payair/google-pay-sdk"
import { GooglePayButtonParams } from "@payair/google-pay-sdk/models/GooglePayButtonParams"
import { GooglePayButtonTypeEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayButtonTypeEnum"
import { GooglePayInitParams } from "@payair/google-pay-sdk/models/GooglePayInitParams"
import store from "../../store/SrciStore"
import { GooglePayIntermediatePaymentData } from "@payair/google-pay-sdk/models/GooglePayIntermediatePaymentData"
import { GooglePayPaymentDataRequestUpdate } from "@payair/google-pay-sdk/models/GooglePayPaymentDataRequestUpdate"
import { getValuesFromLocale } from "@payair/e-com-common-sdk/core/Helpers"
import { GooglePayShippingOptionParameters } from "@payair/google-pay-sdk/models/GooglePayShippingOptionParameters"
const ecomWrapperSdk = PayairEcomWrapperSdk.ecomWrapperSdk
const googlePaySdk = payairGooglePay.googlePaySdk
const GooglePayEventTypeEnums = payairGooglePay.GooglePayEventTypeEnums
const GooglePayEventListenerEnums = payairGooglePay.GooglePayEventListenerEnums

export default function GooglePayWallet() {
  useEffect(() => {
    window.addEventListener(GooglePayEventListenerEnums.PAYAIR_GOOGLE_PAY_SDK_LISTENER, event =>
      onGooglePayListenerEvent(event)
    )

    initCheckout()
  })

  const onGooglePayListenerEvent = (googlePayListenerEvent: any) => {
    const googlePayEvent = googlePayListenerEvent.detail
    console.log("onGooglePayListenerEvent:", googlePayEvent)

    switch (googlePayEvent.eventType) {
      case GooglePayEventTypeEnums.SDK_INITIALIZE_SUCCESS:
        renderGooglePayButton()
        break
      default:
        break
    }
  }

  const renderGooglePayButton = () => {
    const srcGooglePayButtonParams = store.getState().googlepayInputData.googlePayButtonParams

    const googlePayButtonParams: GooglePayButtonParams = {
      buttonColor: srcGooglePayButtonParams.buttonColor,
      buttonType: GooglePayButtonTypeEnumsObj.BUY,
    }
    googlePaySdk.renderButton("googlePayButton", googlePayButtonParams)
  }

  const googlePayOnPaymentDataChanged = (
    intermediatePaymentData: GooglePayIntermediatePaymentData,
    googlePayTotalAmount: string,
    currencyCode: string,
    locale: string,
    googlePayShippingOptionParameters?: GooglePayShippingOptionParameters
  ): GooglePayPaymentDataRequestUpdate => {
    console.log("onPaymentDataChanged", intermediatePaymentData)
    const shippingOptionId = intermediatePaymentData.shippingOptionData?.id

    let shippingCost = "0.00"
    if (!googlePayShippingOptionParameters) {
      shippingCost = "0.00"
    } else if (shippingOptionId === googlePayShippingOptionParameters.shippingOptions[0].id) {
      shippingCost = "30.00"
    } else if (shippingOptionId === googlePayShippingOptionParameters.shippingOptions[1].id) {
      shippingCost = "45.00"
    }

    let totalPrice = parseFloat(googlePayTotalAmount) + parseFloat(shippingCost)

    if (intermediatePaymentData.offerData?.redemptionCodes.includes("PAYLESS")) {
      totalPrice = totalPrice - (totalPrice * 2) / 10
    }

    const googlePayPaymentDataRequestUpdate: GooglePayPaymentDataRequestUpdate = {
      newTransactionInfo: {
        currencyCode: currencyCode,
        countryCode: getValuesFromLocale(locale)?.countryCode,
        totalPrice: totalPrice.toFixed(2).toString(),
        totalPriceStatus: "FINAL",
      },
    }

    console.log("googlePayPaymentDataRequestUpdate", googlePayPaymentDataRequestUpdate)

    return googlePayPaymentDataRequestUpdate
  }

  const initCheckout = () => {
    const srcGooglePayInitParams = store.getState().googlepayInputData.googlePayInitParams
    const generalInput = store.getState().srciInputData.generalInput

    const googlePayInitParams: GooglePayInitParams = {
      currencyCode: generalInput.currencyCode,
      totalAmount: generalInput.totalAmount,
      totalAmountLabel: generalInput.totalAmountLabel,
      merchantName: generalInput.merchantName,
      merchantId: generalInput.merchantId,
      pspName: generalInput.pspName,
      transactionId: "Test tool" + Date.now(),
      environment: generalInput.environment,
      locale: generalInput.locale,

      totalPriceStatus: srcGooglePayInitParams.totalPriceStatus,
      paymentMethodType: srcGooglePayInitParams.paymentMethodType,
      allowedCardNetworks: srcGooglePayInitParams.allowedCardNetworks,
      allowedCardAuthMethods: srcGooglePayInitParams.allowedCardAuthMethods,
      gateway: srcGooglePayInitParams.gateway,
      gatewayMerchantId: srcGooglePayInitParams.gatewayMerchantId,

      billingAddressRequired: srcGooglePayInitParams.billingAddressRequired,

      shippingOptionRequired: srcGooglePayInitParams.shippingOptionRequired,
      shippingOptionParameters: srcGooglePayInitParams.shippingOptionParameters,

      shippingAddressRequired: srcGooglePayInitParams.shippingAddressRequired,
      shippingAddressParameters: srcGooglePayInitParams.shippingAddressParameters,

      enablePromoCodes: srcGooglePayInitParams.enablePromoCodes,
      emailRequired: srcGooglePayInitParams.emailRequired,
      onPaymentDataChanged: (intermediatePaymentData: GooglePayIntermediatePaymentData) =>
        googlePayOnPaymentDataChanged(
          intermediatePaymentData,
          generalInput.totalAmount,
          generalInput.currencyCode,
          generalInput.locale,
          srcGooglePayInitParams.shippingOptionParameters
        ),
    }

    console.log("googlePayInitParams", googlePayInitParams)

    ecomWrapperSdk.initSdk(PayairEcomWrapperSdk.EcomWalletSdkEnums.PAYAIR_GOOGLE_PAY_SDK, googlePayInitParams)
  }

  return (
    <>
      <div id="googlePayButton" />
    </>
  )
}
